import type { Branding } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'

export class BrandingApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  getBranding(): Promise<Branding> {
    return this.edgeClient.getBranding()
  }
}
